import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export function History(props: IconProps): JSX.Element {
  const { ...rest } = props;

  return (
    <SvgIcon name="History" {...rest}>
      <g clipPath="url(#a)">
        <path d="M12 5v7l3 3" stroke="currentColor" strokeWidth="2" />
        <path d="M17 8V2h6l-6 6Z" fill="currentColor" />
        <path
          d="M19.78 4.22c.5.497.95 1.043 1.34 1.63.395.588.73 1.215 1 1.87.275.666.489 1.356.64 2.06a11.312 11.312 0 0 1 0 4.44 12.008 12.008 0 0 1-.64 2.06 10.86 10.86 0 0 1-5.87 5.87 11.99 11.99 0 0 1-2.06.64 11.308 11.308 0 0 1-4.44 0 11.99 11.99 0 0 1-2.06-.64 10.86 10.86 0 0 1-5.87-5.87 12.001 12.001 0 0 1-.64-2.06 11.31 11.31 0 0 1 0-4.44 12 12 0 0 1 .64-2.06 10.86 10.86 0 0 1 5.87-5.87 12 12 0 0 1 2.06-.64 11.31 11.31 0 0 1 4.44 0"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="white" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
